// See: src/scss/abstract/_variables.scss
export const colors = {
    primary: '#16A34A',
    white: '#FFFFFF',
    red: '#E85B5B',
    darkRed: '#FF1515',
    lightRed: '#F17F6F',
    lighterRed: '#fcd2cc',
    grey: '#979797',
    lightGrey: '#D9D9D9',
    greyLight: '#F6F6F6',
    purple: '#9263D0',
    darkPurple: '#9263d026',
    lightGreen: '#81D219',
    lighterGreen: '#F1FDF5',
    black: '#000',
    lighterBlack: '#231F20',
    blue: '#2C70E3',
    lightBlue: '#D5E2F9',
    lighterBlue: '#EAF1FC',
    yellow: '#FFCD52',
    lightYellow: '#fff9eb',
    green: '#8AD1A4',
    InteractionsGreen: '#D0EDDB80',
    limeGreen: '#D0EDDB',
    maroon: '#A96778',
    brown: '#A3743B',
    mediumGrey: '#B6B5B5',
    darkGrey: '#6B6B6B',
    orange: '#F4A261',
    orangeMid: '#ef8200',
    veryLightGreen: '#DCF1E4',
    veryLightRed: '#E5D1D6',
    veryDarkGreen: '#186D2A',
    fluorescentGreen: '#39BE00'
}
